export default __webpack_public_path__ + "static/media/2428.be8d2828.png";